import {
  DndContext,
  PointerSensor,
  KeyboardSensor,
  closestCenter,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
  arrayMove,
} from "@dnd-kit/sortable";
import CatalogCategoryRow from "./CatalogCategoryRow";
import { reorderCategories } from "../../lib/storage";

// Self-contained categories list with drag-and-drop reordering.
// Owns its own DnD wiring so CatalogPanel doesn't have to know about
// dnd-kit at all — keeping that file focused on tab/state coordination.
export default function CategoriesTab({
  categories,
  onCategoriesChange,
  productCountByCategory,
  isMain,
  onEdit,
  onAskDelete,
}) {
  const sensors = useSensors(
    useSensor(PointerSensor, { activationConstraint: { distance: 4 } }),
    useSensor(KeyboardSensor, { coordinateGetter: sortableKeyboardCoordinates })
  );

  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (!over || active.id === over.id) return;
    const oldIndex = categories.findIndex((c) => c.id === active.id);
    const newIndex = categories.findIndex((c) => c.id === over.id);
    if (oldIndex === -1 || newIndex === -1) return;
    const reordered = arrayMove(categories, oldIndex, newIndex);
    onCategoriesChange(reordered);
    onCategoriesChange(reorderCategories(reordered.map((c) => c.id)));
  };

  return (
    <div
      className="bg-white border border-[#E6E0D4] rounded-xl divide-y divide-[#EEE8DC] overflow-hidden"
      data-testid="categories-list"
    >
      {categories.length === 0 && (
        <div className="px-4 md:px-5 py-8 text-center text-sm text-[#0B1F3A]/60">
          No categories yet. Create one to start organising products.
        </div>
      )}
      <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
        <SortableContext items={categories.map((c) => c.id)} strategy={verticalListSortingStrategy}>
          {categories.map((c) => (
            <CatalogCategoryRow
              key={c.id}
              category={c}
              productCount={productCountByCategory[c.name] || 0}
              isMain={isMain}
              onEdit={() => onEdit(c)}
              onAskDelete={() =>
                onAskDelete({
                  id: c.id,
                  name: c.name,
                  count: productCountByCategory[c.name] || 0,
                })
              }
            />
          ))}
        </SortableContext>
      </DndContext>
      {isMain && categories.length > 1 && (
        <p className="px-4 md:px-5 py-3 text-xs text-[#0B1F3A]/55 bg-[#FBF8F1] border-t border-[#EEE8DC]">
          Drag the <span className="inline-block align-text-bottom">⋮⋮</span> handle to reorder. The order applies to product chips and the catalog dropdown.
        </p>
      )}
    </div>
  );
}
